import React from 'react'

import AdditionalInformation from '../components/AdditionalInfo'

const AdditionalInformationScreen: React.FC<React.PropsWithChildren<unknown>> = () => <AdditionalInformation />

export default AdditionalInformationScreen
